import React from 'react';
import {
  WordpressArticle,
  ArticleContentItemRenderer,
  cn,
} from '@ais-ui/utils';
import { Badge, Separator } from '@ais-ui/ui-core';
import { categoryToIcon } from './categoryToIcon';

interface HelpArticleContentProps {
  article: WordpressArticle;
  className?: string;
}

export const HelpArticleContent: React.FC<HelpArticleContentProps> = ({
  article,
  className,
}) => {
  const CategoryIcon = categoryToIcon(article.categories || []);

  return (
    <div
      className={cn(
        'prose prose-slate dark:prose-invert max-w-none',
        className
      )}
    >
      {/* Article Header */}
      <div className="not-prose mb-8">
        {/* Category Badge */}
        {article.categories?.[0] && (
          <div className="flex items-center mb-4">
            <Badge variant="secondary" className="flex items-center gap-2">
              <CategoryIcon className="h-3 w-3" />
              <span className="capitalize">{article.categories[0]}</span>
            </Badge>
          </div>
        )}

        {/* Title */}
        <h1 className="text-3xl font-bold tracking-tight mb-2">
          {article.title.rendered}
        </h1>

        {/* Subtitle */}
        {article.subtitle && (
          <p className="text-xl text-muted-foreground mb-6">
            {article.subtitle}
          </p>
        )}

        <Separator className="mb-8" />
      </div>

      {/* Article Content */}
      <div className="space-y-6">
        {article.acf?.marinepulse_content?.map((contentItem, index) => (
          <div key={index} className="not-prose">
            <ArticleContentItemRenderer
              articleContentItem={contentItem}
              className="prose prose-slate dark:prose-invert max-w-none"
            />
          </div>
        )) || (
          <div className="text-muted-foreground italic">
            No content available for this article.
          </div>
        )}
      </div>

      {/* Article Footer */}
      <div className="not-prose mt-12 pt-8 border-t">
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <div>
            Last updated: {new Date(article.modified).toLocaleDateString()}
          </div>
          {/* Add feedback or edit links here if needed */}
        </div>
      </div>
    </div>
  );
};
